import { createReducer } from 'redux-act';
import { setSiteMessages, clearSiteMessages } from './siteMessageActions';

const initialState = {
  search: undefined,
  property: undefined,
  booking: undefined,
};

export const reducer = createReducer(
  {
    [setSiteMessages]: (state, { search, property, booking }) => ({ ...state, search, property, booking }),
    [clearSiteMessages]: (state) => ({ ...state, search: undefined, property: undefined, booking: undefined }),
  },
  initialState,
);
